/*
*   List of Actions with TYPE that should be passed from employees.reducer.js to import.reducer.js
 */

export const PREFIX = 'EMPLOYEES_IMP_SETTINGS';

export const TYPES = {
     FETCH_COST_CENTER_DETAILS:           `${PREFIX}_FETCH_COST_CENTER_DETAILS`,
};
